<template>
  <div>
    <div>
      <div class="progress-bar-envelope">
        <el-progress :text-inside="true" :stroke-width="18" :percentage="rawImportProgress.percentage" color="rgba(142, 113, 199, 0.7)"></el-progress>
      </div>
      <div class="text-block">{{rawImportProgress.text}}</div>
    </div>
    <div>
      <div class="progress-bar-envelope">
        <el-progress :text-inside="true" :stroke-width="18" :percentage="createEDeliveryEventProgress.percentage" color="rgba(1, 113, 199, 0.7)"></el-progress>
      </div>
      <div  class="text-block">{{createEDeliveryEventProgress.text}}</div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
import config from '@/config'

export default {
  name: 'e-delivery-tasks-state',
  props: ['companyId'],
  data () {
    return {
      loading: true,
      tasksState: {},
      loadAndroidTimerRef: null,
    }
  },
  computed: {
    sendEmailsProgress () {
      let sendEmailsTotal = this.tasksState.send_emails_total
      let sendEmailsCurrent = this.tasksState.send_emails_current
      if (sendEmailsTotal === '' || sendEmailsTotal === undefined) {
        return {
          percentage: 0,
          text: 'Send Emails (pending)'
        }
      }
      sendEmailsTotal = parseInt(sendEmailsTotal)
      sendEmailsCurrent = parseInt(sendEmailsCurrent)
      if (sendEmailsTotal === 0) {
        return {
          percentage: 100,
          text: 'Send Emails (no new data)'
        }
      }
      return {
        percentage: Math.trunc(1000 * sendEmailsCurrent/sendEmailsTotal)/10,
        text: 'Send Emails'
      }
    },
    createEDeliveryEventProgress () {
      let createEdeliveryEventsTotal = this.tasksState.create_edelivery_events_total
      let createEdeliveryEventsCurrent = this.tasksState.create_edelivery_events_current
      if (createEdeliveryEventsTotal === '' || createEdeliveryEventsTotal === undefined) {
        return {
          percentage: 0,
          text: 'Create EDelivery Event(pending)'
        }
      }
      createEdeliveryEventsTotal = parseInt(createEdeliveryEventsTotal)
      createEdeliveryEventsCurrent = parseInt(createEdeliveryEventsCurrent)
      if (createEdeliveryEventsTotal === 0) {
        return {
          percentage: 100,
          text: 'Create EDelivery Event(no new data)'
        }
      }
      return {
        percentage: Math.trunc(1000*createEdeliveryEventsCurrent/createEdeliveryEventsTotal)/10,
        text: 'Create EDelivery Event'
      }
    },
    rawImportProgress () {
      let rawImportTotal = this.tasksState.raw_import_total
      let rawImportCurrent = this.tasksState.raw_import_current
      if (rawImportTotal === '' || rawImportTotal === undefined) {
        return {
          percentage: 0,
          text: 'Raw Import (pending)'
        }
      }
      rawImportTotal = parseInt(rawImportTotal)
      rawImportCurrent = parseInt(rawImportCurrent)
      if (rawImportTotal === 0) {
        return {
          percentage: 100,
          text: 'Raw Import (no new data)'
        }
      }
      return {
        percentage: Math.trunc(1000*rawImportCurrent/rawImportTotal)/10,
        text: 'Raw Import'
      }
    },
  },
  methods: {
    loadTasksState () {
      this.loading = true
      clearTimeout(this.loadAndroidTimerRef)
      axios.get(`${config.url}/company/${this.companyId}/edelivery_tasks_progress/`)
        .then(response => {
          this.tasksState = response.data.data
        })
        .finally(() => {
          this.loading = false
          this.loadAndroidTimerRef = setTimeout(this.loadTasksState, 3000)
        })
    },
  },
  beforeMount () {
    this.loadTasksState()
  },
  beforeDestroy () {
    clearTimeout(this.loadAndroidTimerRef)
  }
}
</script>

<style scoped>
  .progress-bar-envelope {
    width: 300px;
    display:inline-block;
  }
  .text-block {
    display:inline-block
  }
</style>